import { IRoute } from "app/auth/models/utils-interfaces";
import { AuthGuard } from "../../auth/helpers";
import { ProvidersCostListComponent } from "./pages/providers-cost/providers-cost-list/providers-cost-list.component";
import { StructureCostListComponent } from "./pages/structure-cost/strcture-cost-list/structure-cost-list.component";

const costRoutes: IRoute[] = [
  {
    path: "dashboard/costs/providers-cost-list",
    component: ProvidersCostListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/costs/structure-cost-list",
    component: StructureCostListComponent,
    canActivate: [AuthGuard],
  },
];
export default costRoutes;
